import VueRecaptcha from 'vue-recaptcha'

// leave the export, even if you don't use it
export default ({ app, router, Vue }) => {
  Vue.component('vue-recaptcha', VueRecaptcha)
}
